import React, { useState } from 'react'
import styled from 'styled-components'

import { usePeer } from '../hooks/peer'
import { generate_code } from '../utils/generate_code'

export default (props) => {
	const [code] = useState(generate_code())

	const { new_data } = usePeer({ init: true, code })

	return (
		<Container>
			<Section top>
				<Header>{code}</Header>
				<Text top>share code with friend</Text>
			</Section>
			<Section>
				{new_data ? (
					new_data.new_room && <Text bottom>waiting for friend</Text>
				) : (
					<Text bottom>connecting</Text>
				)}
			</Section>
		</Container>
	)
}

const Container = styled.section`
	height: 100%;
	display: flex;
	flex-direction: column;
`
const Section = styled.section<{ top? }>`
	flex: 1;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: ${({ top }) => top && 'flex-end'};
	background: ${({ theme }) => theme.colors.white};
`
const Header = styled.h1`
	font-size: 4rem;
	font-weight: 600;
	letter-spacing: 0.5rem;
	margin-bottom: 0.5rem;
	color: ${({ theme }) => theme.colors.primary};
`
const Text = styled.p<{ top?; bottom? }>`
	font-size: 1.1rem;
	color: ${({ theme, top }) => top && theme.colors.grey[1]};
	font-style: ${({ top }) => top && 'italic'};
	margin-top: ${({ bottom }) => bottom && '5rem'};
`
